import { render, staticRenderFns } from "./RegisterV2.vue?vue&type=template&id=18c3ab81&scoped=true"
import script from "./RegisterV2.vue?vue&type=script&lang=js"
export * from "./RegisterV2.vue?vue&type=script&lang=js"
import style0 from "./RegisterV2.vue?vue&type=style&index=0&id=18c3ab81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c3ab81",
  null
  
)

export default component.exports